// Common interfaces and types for retail billing

export interface BaseResponse {
  id: number;
  created_by: number;
  created_at: string;
  updated_by: number;
  updated_at: string;
}

export interface PagedResults<T> {
  items?: T[];
  total_items: number;
  total_pages: number;
  current_page: number;
  page_size: number;
}

export interface CreateResponseData {
  id: number;
  success: boolean;
  message?: string;
}

export interface UpdateResponseData {
  success: boolean;
  message?: string;
}

export interface ValidationError {
  message?: string;
  details?: string[];
}

export enum EntityLevel {
  Company = 'Company',
  Tenant = 'Tenant'
}

export interface FilterRequest {
  search_term?: string;
  page?: number;
  page_size?: number;
}